import "./Teams.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { BarLoader } from "react-spinners";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { useCookies } from "react-cookie";
import { Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { Pagination } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { BaseURL } from "../../../Hooks/URL";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "name",
    label: "Team Name",
    minWidth: 100,
  },
  {
    id: "code",
    label: "Team Code",
    minWidth: 100,
  },
  {
    id: "coach",
    label: " Coach Name",
    minWidth: 100,
  },
  {
    id: "category",
    label: "Category",
    minWidth: 100,
  },
  { id: "ageGroup", label: "Age Group", minWidth: 100 },
  { id: "organizationBranch", label: "Organization", minWidth: 100 },
  { id: "account", label: "Account Code", minWidth: 100, paid: false },
  {
    id: "account",
    label: "Discount Percentage",
    minWidth: 100,
    discount: true,
  },
  { id: "account", label: "Account Paid", minWidth: 100, paid: true },
];

function Teams({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  teams,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  filters,
  teamsNumber,
  setPage,
  sortBy,
  sortOrder,
  handleSortChange,
  handleSortOrderChange,
  handleFilterChange,
  categories,
  getFilterQueryString,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showFilters, setShowFilters] = useState(!isMobile);
  const [discountPercentage, setDiscountPercentage] = useState("");

  return (
    <div className="mainContainer">
      <div className="cont">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Total Teams: {teamsNumber}</h2>
          <a
            href={`${BaseURL}/admin/dashboard/teams/excel?${
              sortBy ? `&sortBy=${sortBy}` : ""
            }${sortOrder ? `&sortDesc=${sortOrder}` : ""}${
              getFilterQueryString(filters)
                ? `&${getFilterQueryString(filters)}`
                : ""
            }${search ? `&search=${search}` : ""}&timeZone=${
              Intl.DateTimeFormat().resolvedOptions().timeZone
            }`}
            target="_blank"
          >
            <PrimaryButton
              classBtn={"center editButton"}
              text={"Download Excel"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--text-primary)",
                height: "40px",
                padding: "0 30px",
                fontSize: "15px",
              }}
            />
          </a>
        </Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {isMobile && (
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                backgroundColor: "var(--primary)",
                color: "white",
                "&:hover": {
                  backgroundColor: "#8a0505",
                },
              }}
            >
              <FilterListIcon />
            </IconButton>
          )}
        </Box>

        <Collapse in={showFilters}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Search"}
                className="SearchBar"
                name={"search"}
                change={(e) => setSearchData(e.target.value)}
                newValue={searchData}
                searchAction={() => {
                  if (search != searchData) {
                    setSearch(searchData);
                    setPage(0);
                  }
                }}
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    if (search != searchData) {
                      setSearch(searchData);
                      setPage(0);
                    }
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  label="Sort By"
                  onChange={handleSortChange}
                  defaultValue={sortBy}
                >
                  {[
                    { id: "name", label: "Team Name" },
                    { id: "code", label: "Team Code" },
                    { id: "accountCode", label: "Account Code" },
                  ].map((column) => (
                    <MenuItem key={column.id} value={column.id}>
                      {column.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Order</InputLabel>
                <Select
                  value={sortOrder}
                  label="Order"
                  onChange={handleSortOrderChange}
                >
                  <MenuItem value={false}>
                    {sortBy == "name" ? "A-Z" : "Lowest to Highest"}
                  </MenuItem>
                  <MenuItem value={true}>
                    {sortBy == "name" ? "Z-A" : "Highest to Lowest"}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Account Paid</InputLabel>
                <Select
                  value={filters?.accountPaid}
                  label="Account Paid"
                  name="accountPaid"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>Paid</MenuItem>
                  <MenuItem value={0}>Unpaid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Competition Type</InputLabel>
                <Select
                  value={filters?.competitionType}
                  label="Competition Type"
                  name="competitionType"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                  <MenuItem value="onlineOnly">Online Only</MenuItem>
                  <MenuItem value="offline">Offline</MenuItem>
                  <MenuItem value="offlineOnly">Offline Only</MenuItem>
                  <MenuItem value="both">Both</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={filters?.categoryId}
                  label="Category"
                  name="categoryId"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  {categories?.map((category) => (
                    <MenuItem value={category.id}>{category.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Age Group</InputLabel>
                <Select
                  value={filters?.ageGroupId}
                  label="Age Group"
                  name="ageGroupId"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  {categories
                    ?.filter((category) => category.id === filters?.categoryId)
                    ?.map((category) =>
                      category.ageGroups.map((ageGroup) => (
                        <MenuItem value={ageGroup.id}>{ageGroup.name}</MenuItem>
                      ))
                    )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Has Discount</InputLabel>
                <Select
                  value={filters?.hasDiscount}
                  label="Has Discount"
                  name="hasDiscount"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Discount Percentage"}
                className="SearchBar"
                name={"discountPercentage"}
                change={(e) => setDiscountPercentage(e.target.value)}
                newValue={discountPercentage}
                searchAction={() =>
                  handleFilterChange({
                    target: {
                      name: "discountPercentage",
                      value: discountPercentage,
                    },
                  })
                }
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    handleFilterChange({
                      target: {
                        name: "discountPercentage",
                        value: discountPercentage,
                      },
                    });
                }}
              />
            </Grid>
          </Grid>
        </Collapse>

        <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {teams && !loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teams?.map((team, i) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={team.id}
                          style={{ cursor: "pointer" }}
                        >
                          {columns.map((column) => {
                            const value = team[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id === "onlineParticipant" ||
                                column.id === "offlineParticipant" ? (
                                  value ? (
                                    <DoneIcon className="activatedTick" />
                                  ) : (
                                    <CloseIcon className="NonActivatedTick" />
                                  )
                                ) : column.id == "category" ||
                                  column.id == "ageGroup" ? (
                                  value?.name
                                ) : column.id == "account" &&
                                  column.discount ? (
                                  value?.discountPercentage ? (
                                    `${value?.discountPercentage}%`
                                  ) : (
                                    "-"
                                  )
                                ) : column.id == "account" ? (
                                  column.paid ? (
                                    value.paid ? (
                                      <DoneIcon className="activatedTick" />
                                    ) : (
                                      <CloseIcon className="NonActivatedTick" />
                                    )
                                  ) : (
                                    <span
                                      style={{ textDecoration: "underline" }}
                                      onClick={() =>
                                        navigate(`/accounts/${value?.id}`)
                                      }
                                    >
                                      {value?.code}
                                    </span>
                                  )
                                ) : column.id == "coach" ? (
                                  value?.name
                                ) : column.id == "organizationBranch" ? (
                                  value?.organization?.name ?? "-"
                                ) : (
                                  value ?? "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!teams?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No teams Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0 20px`",
                  padding: "20px",
                  color: "var(--primary)",
                  "& .Mui-selected": {
                    backgroundColor: "var(--primary)",
                    color: "white",
                  },
                }}
              />
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default Teams;
